export default function Phase3() {
  return (
    <>
      <h2 className="cs-h2 cs-h2-tight">
        Phase 3: Google My Business Optimization

      </h2>

      <h3 className="cs-h3">
       GMB as Local Authority & Trust Signal
      </h3>

      <p className="cs-p">
        While Meta advertising drove lead generation, Google My Business served critical functions in the customer journey: local search visibility for "interior designers near me" queries, trust validation through reviews and portfolio, conversion support for prospects researching Aruh Koncepts after initial awareness, and SEO authority building for organic discovery.
      </p>

      <h3 className="cs-h3">
        Profile Optimization
      </h3>

      <p className="cs-p">
            Complete business information with keyword optimization: business name, category, description emphasizing premium positioning, service area covering target Hyderabad neighborhoods, business hours, contact information, website and booking links.
            Visual content strategy included high-quality portfolio photography showcasing completed projects, regular updates (2-3 per week) with new project images, behind-the-scenes content showing design process, video content including project walkthroughs and client testimonials, and 360-degree virtual tours of completed spaces.
      </p>

       <h3 className="cs-h3">
        Review Generation & Management
      </h3>

      <p className="cs-p">
           Systematic review acquisition from satisfied clients: post-project follow-up requesting Google reviews, guidance provided on effective review content (mentioning specific services, budget satisfaction, process experience), response protocols for all reviews within 24 hours, and showcase of reviews highlighting premium service and investment value.
            Review content strategically addressed common prospect concerns: "Worth every rupee—the attention to detail and quality of execution exceeded expectations," "Professional team that understood our vision and delivered on time and within budget," "Transparent pricing and no hidden costs—they clearly outlined investment from the start."

      </p>

       <h3 className="cs-h3">
       GMB Posts Strategy
      </h3>

      <p className="cs-p">
           Regular posts keeping profile active and engaging: project showcases with before-after imagery, design tips and inspiration content, service highlights explaining specific offerings, special promotions or consultation offers, and event content from design exhibitions or studio events.
           Posts included clear calls-to-action driving website visits, consultation bookings, or phone inquiries.

      </p>

       <h3 className="cs-h3">
       Q&A Optimization
      </h3>

      <p className="cs-p">
           Proactive seeding of common questions with detailed answers: "What is your typical project timeline?" "What budget range should I plan for full-home interiors?" "Do you handle both design and execution?" "What areas of Hyderabad do you serve?" "How does your consultation process work?"
           Answers were detailed, transparent, and reinforced premium positioning while preemptively addressing prospect concerns.

      </p>


       <h3 className="cs-h3">
       Local SEO Integration
      </h3>

      <p className="cs-p">
           GMB optimization supported broader local search strategy: consistent NAP (Name, Address, Phone) across all online directories, local keyword optimization in description and posts, geographic signal reinforcement through area-specific content, backlink acquisition from Hyderabad real estate and home improvement directories, and citation building in relevant local business listings.

      </p>


      



      {/* Entire Phase 1 content */}
    </>
  );
}